export default __webpack_public_path__ + "static/media/example-tracking-image.775f3d2f.zpt";